import { render, staticRenderFns } from "./ModalBuscarTabelaPreco.vue?vue&type=template&id=03e2b842&scoped=true&"
import script from "./ModalBuscarTabelaPreco.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarTabelaPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2b842",
  null
  
)

export default component.exports